// extracted by mini-css-extract-plugin
export default {"th":"WalletFIIsList_th__1Gys7","td":"WalletFIIsList_td__wPDP8","emphasis":"WalletFIIsList_emphasis__hyJej"};